import { atom } from "recoil";

export const isLoading = atom<boolean>({
  key: "isLoading", // unique ID (with respect to other atoms/selectors)
  default: false, // default value (aka initial value)
});
